module.exports = __webpack_public_path__ + "img/公众号.e299cef0.png";